import React from 'react';
import '../spinner.css'; 

const Spinner = () => {
  return (
    <div className="spinner-small-container">
      <div className="spinner-small"></div>
    </div>
  );
};

export default Spinner;